export function regexEscape(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") // $& means the whole matched string
}
